export default __webpack_public_path__ + "static/media/user-edit.070b6d40.svg";